module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "conInner"
  }, [_c('section', {
    attrs: {
      "id": "content_wrapper"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "top"
  }), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [(!_vm.recordList.length) ? _c('div', {
    staticClass: "empty"
  }, [_vm._v("暂无信息")]) : _vm._e(), _vm._v(" "), (_vm.recordList.length) ? _c('table', {
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "width": "100%"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.recordList), function(row) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(row.create_time))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.money))])])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.recordList.length) ? _c('div', {
    staticClass: "pager_border"
  }, [_c('Page', {
    ref: "pages",
    attrs: {
      "total": _vm.dataTotal,
      "show-total": "",
      "page-size": _vm.pageSize,
      "size": "small",
      "show-elevator": ""
    },
    on: {
      "on-change": _vm.changepage
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "data"
  }, [_c('h2', [_vm._v("我的积分获取记录")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "top"
  }), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('img', {
    attrs: {
      "src": "//static.kxymall.com/images/gth.jpg"
    }
  }), _vm._v(" "), _c('div', [_c('h2', [_vm._v("温馨提示")]), _vm._v(" "), _c('p', [_vm._v("1、每日签到获得2张现金券")])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("获取日期")]), _vm._v(" "), _c('th', [_vm._v("获取原因")]), _vm._v(" "), _c('th', [_vm._v("金额(元)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-325ff936"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/member-center/right/myShoppingScore.vue
// module id = 1567
// module chunks = 1